export const CLASSIFICATIONS = [
  'potentially_vulnerable',
  'version_suggests_fixed',
  'php_version_unknown',
  'no_php_evidence',
  'inconclusive',
] as const;

export type Classification = (typeof CLASSIFICATIONS)[number];

export const SEVERITIES = ['potential_risk', 'likely_patched', 'inconclusive'] as const;

export type Severity = (typeof SEVERITIES)[number];

export const EVIDENCE_STATUSES = [
  'observed',
  'weak_indicator',
  'not_observable',
  'not_verified',
] as const;

export type EvidenceStatus = (typeof EVIDENCE_STATUSES)[number];

export const CLASSIFICATION_LABELS: Record<Classification, string> = {
  potentially_vulnerable: 'Potentially Vulnerable',
  version_suggests_fixed: 'Version Evidence Suggests Fixed',
  php_version_unknown: 'PHP Detected — Version Unknown',
  no_php_evidence: 'No Public PHP Evidence Found',
  inconclusive: 'Scan Inconclusive',
};

export const SEVERITY_LABELS: Record<Severity, string> = {
  potential_risk: 'Potential Risk',
  likely_patched: 'Likely Patched',
  inconclusive: 'Inconclusive',
};

export const EVIDENCE_STATUS_LABELS: Record<EvidenceStatus, string> = {
  observed: 'Observed',
  weak_indicator: 'Weak indicator',
  not_observable: 'Not observable',
  not_verified: 'Not verified',
};

export function severityFor(classification: Classification): Severity {
  if (classification === 'potentially_vulnerable') return 'potential_risk';
  if (classification === 'version_suggests_fixed') return 'likely_patched';
  return 'inconclusive';
}
